module.exports = __webpack_public_path__ + "img/2-3.e238da2a.svg";